import jquery from "jquery";

function getUnicodeFlag(countryCode: string): string {
  const codePoints = countryCode
    .toUpperCase()
    .split("")
    .map((char) => 127397 + char.charCodeAt(0));
  return String.fromCodePoint(...codePoints);
}

jquery(async () => {
  const response = await fetch("/api/v1/regional_discount/");

  if (!response.ok) {
    return;
  }

  const data = await response.json();

  if (
    data.discount_percent > 0 &&
    data.country_name != null &&
    data.country_code != null &&
    data.short_url != null
  ) {
    const { discount_percent, country_name, country_code, short_url, name } =
      data;
    const boxClass = "price-box__regional_discount";

    jquery(".price-box__button").replaceWith(
      jquery("<div />")
        .addClass(boxClass)
        .append(
          jquery("<div />")
            .addClass(`${boxClass}__title`)
            .append(
              jquery("<span />")
                .addClass(`${boxClass}__flag`)
                .text(getUnicodeFlag(country_code))
            )
            .append(name)
        )
        .append(
          jquery("<div />").html(
            `Looks like you are from ${country_name}. ` +
              `We offer a <b>${discount_percent}% regional discount</b>.`
          )
        )
        .append(
          jquery("<a />")
            .addClass(`${boxClass}__activate`)
            .text(`Activate ${discount_percent}% off`)
            .attr("href", short_url)
        )
    );
  }
});
